import React, { useContext, useEffect, useState } from 'react';
import { preferencesApi } from '@/core/preferences/export';
import { WidgetBase, WidgetContainerContext } from '@/core/widgets/export';
import { SidePanelId, SidePanelUiContext } from '@/core/deep-dive/contexts/side-panel-provider';
import { Loading } from '@/shared/components/export';

export default function PanelWidgetContainerContext({
  widget,
  panelId,
  children,
}: React.PropsWithChildren<{ widget: WidgetBase; panelId: SidePanelId }>) {
  const sidePanelUi = useContext(SidePanelUiContext);
  const [state, setState] = useState<any>({});
  const [preferences, setPreferences] = useState<any>(undefined);

  const preferencesKey = () => `widget-${widget.id}`;

  useEffect(() => {
    setState(widget?.initialState?.() ?? {});
    setPreferences(undefined);
    preferencesApi
      .getPreferences(preferencesKey())
      .then(value => setPreferences(value || {}))
      .catch(() => setPreferences({}));
    // eslint-disable-next-line
  }, [widget]);

  return (
    <WidgetContainerContext.Provider
      value={{
        get widgetId(): string | undefined {
          return widget.id;
        },
        getPreferences<T>(): T | undefined {
          return preferences;
        },
        setPreferences<T>(next: T): void {
          setPreferences(next);
          preferencesApi.overwritePreferences(preferencesKey(), next);
        },
        updatePreferences<T>(partial: Partial<T>): void {
          setPreferences((prev: any) => ({ ...prev, ...partial }));
          preferencesApi.upsertPreferences(preferencesKey(), partial);
        },
        setState<T>(next: T): void {
          setState(next);
        },
        updateState<T>(partial: Partial<T>): void {
          setState((prev: any) => ({ ...prev, ...partial }));
        },
        getState() {
          return state;
        },
        close() {
          sidePanelUi.closePanel(panelId);
        },
      }}
    >
      {preferences ? children : <Loading />}
    </WidgetContainerContext.Provider>
  );
}
